import { SvgIconProps } from "@mui/material";
import { ThemedFillSvgIcon } from "src/theme-mui/components/svg-icon/themed-fill-svg-icon";

export const IconInfoOuterCircle = (props: SvgIconProps) => (
    <ThemedFillSvgIcon {...props} viewBox="0 0 16 16">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
                d="M16.875 9C16.875 13.3489 13.3492 16.875 9.00056 16.875C4.6508 16.875 1.125 13.3489 1.125 9C1.125 4.65105 4.6508 1.125 9.00056 1.125C13.3492 1.125 16.875 4.65105 16.875 9"
                stroke="#333333"
                strokeWidth="1.6875"
            />
            <rect x="7.875" y="7.875" width="2.25" height="5.625" rx="1.125" fill="#333333" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.875 5.6254C7.875 5.00349 8.37894 4.5 8.9996 4.5C9.62106 4.5 10.125 5.00349 10.125 5.6254C10.125 6.24651 9.62106 6.75 8.9996 6.75C8.37894 6.75 7.875 6.24651 7.875 5.6254Z"
                fill="#333333"
            />
        </svg>
    </ThemedFillSvgIcon>
);
